import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { UpdatedSalesInvoice } from "features/stock-ordering/core/stock-ordering.params";
import {
  updatedSalesInvoiceApprovalResponse,
  updatedSalesInvoiceApprovalRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum UpdatedSalesInvoiceApprovalState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: UpdatedSalesInvoiceApprovalState;
  message: string;
}

const initialState: InitialState = {
  status: UpdatedSalesInvoiceApprovalState.initial,
  message: "",
};

export const updatedSalesInvoiceApproval = createAsyncThunk(
  "updatedSalesInvoiceApproval",
  async (param: UpdatedSalesInvoice, { rejectWithValue }) => {
    try {
      const response: updatedSalesInvoiceApprovalResponse =
        await updatedSalesInvoiceApprovalRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const updatedSalesInvoiceApprovalSlice = createSlice({
  name: "updatedSalesInvoiceApproval",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatedSalesInvoiceApproval.pending, (state) => {
        state.status = UpdatedSalesInvoiceApprovalState.inProgress;
      })
      .addCase(updatedSalesInvoiceApproval.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = UpdatedSalesInvoiceApprovalState.success;
          state.message = message;
        }
      })
      .addCase(updatedSalesInvoiceApproval.rejected, (state, action) => {
        state.status = UpdatedSalesInvoiceApprovalState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectUpdatedSalesInvoiceApproval = (state: RootState) =>
  state.updatedSalesInvoiceApproval;

export default updatedSalesInvoiceApprovalSlice.reducer;
